import React, { useState, useEffect } from 'react';
import { Box, TextField, MenuItem } from '@mui/material';

const CountConditions = ({ value, onChange }) => {
    const [objectType, setObjectType] = useState(value.objectType || '');
    const [threshold, setThreshold] = useState(value.threshold || 0);

    useEffect(() => {
        onChange({ threshold});
    }, [threshold, onChange]);


    return (
        <Box>
            <TextField
                type="number"
                label="Count Threshold"
                value={threshold}
                onChange={(e) => setThreshold(Number(e.target.value))}
                fullWidth
                margin="dense"
                inputProps={{ min:0 }}
            />
        </Box>
    );
};

export default CountConditions;
